import { ApiPaths } from './ApiPaths';
import BaseApi from './BaseApi';

/**
 * API for managing account data information
 */
const create = () => {
    // Create BaseApi instance with provided options
    const api = BaseApi.create({});

    const getAccountInformation = () => api.get(ApiPaths.GET_ACCOUNT_SETTINGS);
    
    // Return back a collection of functions
    return {
        getAccountInformation
    }
}

// let's return back our create method as the default.
export default {
    create
}